/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CourseRegistrationManagementAttachmentGroupViewModel } from "../types/CourseRegistrationManagementAttachmentGroupViewModel.ts";
import { courseRegistrationManagementAttachmentViewModelSchema } from "./courseRegistrationManagementAttachmentViewModelSchema.ts";

export const courseRegistrationManagementAttachmentGroupViewModelSchema =
  z.object({
    documentAttachmentTypeText: z
      .string()
      .describe("Descrição textual do tipo de documento exigido.")
      .nullish(),
    documentAttachmentType: z.optional(
      z.number().int().describe("ID do tipo de documento de anexo."),
    ),
    enrollmentDocumentId: z.optional(
      z
        .number()
        .int()
        .describe("ID do documento de matrícula associado ao grupo."),
    ),
    documentationStatus: z.optional(
      z
        .number()
        .int()
        .describe(
          "Status da documentação do grupo (ex.: pendente, aprovado, rejeitado).",
        ),
    ),
    rejectReason: z
      .string()
      .describe("Motivo de rejeição do documento. Opcional.")
      .nullish(),
    approvedByPersonName: z
      .string()
      .describe("Nome da pessoa que aprovou o documento. Opcional.")
      .nullish(),
    rejectedByPersonName: z
      .string()
      .describe("Nome da pessoa que rejeitou o documento. Opcional.")
      .nullish(),
    aprrovedDate: z
      .string()
      .datetime()
      .describe("Data de aprovação do documento. Opcional.")
      .nullish(),
    rejectedDate: z
      .string()
      .datetime()
      .describe("Data de rejeição do documento. Opcional.")
      .nullish(),
    files: z
      .array(
        z.lazy(() => courseRegistrationManagementAttachmentViewModelSchema),
      )
      .describe("Lista de arquivos enviados para este tipo de documento.")
      .nullish(),
  }) as unknown as ToZod<CourseRegistrationManagementAttachmentGroupViewModel>;
